import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'react-bootstrap/Popover'
import { Button } from '../../../../../../../components'
import { OverlayTrigger } from 'react-bootstrap'

const AddToJobList = ({ onClick, disabled, isEditMode }) => {
  return disabled ? (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      rootClose
      rootCloseEvent="mousedown"
      placement="top"
      overlay={
        <Popover id="SASC-A">
          <div className="popover__body">
            {isEditMode ? 'Click Save Changes above.' : 'Please make a selection in the output.'}
          </div>
        </Popover>
      }
    >
      <div>
        <Button disabled style={{ pointerEvents: 'none' }} className="button -xsmall">
          Add to Job list
        </Button>
      </div>
    </OverlayTrigger>
  ) : (
    <Button id="add-to-joblist" className="button -xsmall" onClick={onClick}>
      Add to Job list
    </Button>
  )
}

AddToJobList.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isEditMode: PropTypes.bool,
}

AddToJobList.defaultProps = {
  disabled: false,
  isEditMode: false,
}

export default AddToJobList
